import type { IColumn } from '@/interfaces';
import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';

export const entityColumnsQueryOptions = (entityTypeId: string) => {
  return queryOptions({
    queryKey: ['entityColumns', entityTypeId],
    queryFn: async () => {
      const response = await axios.get<IColumn[]>(
        `/${entityTypeId}/grid-columns`
      );
      if (response.status !== 200) {
        throw new Error('Failed to fetch columns');
      }
      return response.data;
    },
  });
};
